import * as React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { setMapCursor } from '@openlayers/ol-utils';
import { transform as olTransform } from 'ol/proj';
import { unByKey } from 'ol/Observable';
import { MapWrapper } from '@openlayers/MapWrapper';
import { MapToolsStore } from '@openlayers/MapToolsStore';

export class LatLonMapPicker extends React.Component<{
    disabled: boolean;
    latLon: [number, number];
    onChange: (latLon: [number, number]) => void;
    mapWrapper: MapWrapper;
    mapTools: MapToolsStore;
    activateOnMount: boolean;
}> {
    state = {
        positionMode: false,
    };

    destinationClickHandler = null;

    componentDidMount() {
        if (this.props.activateOnMount) {
            this.handleLocationSelection();
            document.querySelector('#image-edit-position-form')?.classList.add('flash-background');
        }
    }

    componentWillUnmount() {
        if (this.destinationClickHandler) {
            unByKey(this.destinationClickHandler);
        }
    }

    render() {
        const { disabled, latLon = [null, null] } = this.props;

        return (
            <div id='image-edit-position-form'>
                <table>
                    <tbody>
                        <tr>
                            <td>lat:</td>
                            <td>
                                <InputNumber
                                    onValueChange={e => this.props.onChange([e.value, latLon[1]])}
                                    value={latLon[0]}
                                    disabled={disabled}
                                    min={-90}
                                    max={90}
                                    locale='en-US'
                                    inputStyle={{ width: '100%' }}
                                    mode='decimal'
                                    useGrouping={false}
                                    minFractionDigits={0}
                                    maxFractionDigits={12}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>lon:</td>
                            <td>
                                <InputNumber
                                    onValueChange={e => this.props.onChange([latLon[0], e.value])}
                                    value={latLon[1]}
                                    disabled={disabled}
                                    min={-180}
                                    max={180}
                                    locale='en-US'
                                    inputStyle={{ width: '100%' }}
                                    mode='decimal'
                                    useGrouping={false}
                                    minFractionDigits={0}
                                    maxFractionDigits={12}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.props.mapWrapper && (
                    <>
                        {!this.state.positionMode ? (
                            <div>
                                <button className='js-location-btn' style={{ flexDirection: 'column' }} disabled={disabled} onClick={this.handleLocationSelection}>
                                    <i className='iki iki-map-pin'></i>
                                    <span style={{ whiteSpace: 'pre-wrap' }}>{__('js_images.select_location')}</span>
                                </button>
                            </div>
                        ) : (
                            <div>
                                {__('js_images.select_location_click')} | <a onClick={this.cancelLocationSelection}>{__('general.cancel')}</a>
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }

    handleLocationSelection = () => {
        this.setState({ positionMode: true });

        setMapCursor(this.props.mapWrapper.getInstance(), 'crosshair');
        this.props.mapTools.activeTool = 'document-select';

        this.destinationClickHandler = this.props.mapWrapper.events.onClickOnce(e => {
            setMapCursor(this.props.mapWrapper.getInstance(), '');
            this.props.mapTools.activeTool = null;
            const coords = e.coordinate;
            const [lon, lat] = olTransform(coords, 'EPSG:3857', 'EPSG:4326');

            this.setState({ positionMode: false });
            this.props.onChange([lat, lon]);
        });
    };

    cancelLocationSelection = e => {
        setMapCursor(this.props.mapWrapper.getInstance(), '');
        this.props.mapTools.activeTool = null;
        unByKey(this.destinationClickHandler);
        this.setState({ positionMode: false });
    };
}
